import React, { Component } from 'react';
import { AutoComplete, MenuItem } from 'material-ui';
import Marker from 'material-ui/svg-icons/maps/place';
import PropTypes from 'prop-types';

class GooglePlaceAutocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      searchText: this.props.value ? this.props.value : '',
      IsFullAddress: this.props.IsFullAddress ? true : false,
    };

    const google = window.google;
    this.geocoder = new google.maps.Geocoder();

    // Documentation for AutocompleteService
    // https://developers.google.com/maps/documentation/javascript/places-autocomplete#place_autocomplete_service
    this.service = new google.maps.places.AutocompleteService(null);

    // binding for functions
    this.updateInput = this.updateInput.bind(this);
    this.populateData = this.populateData.bind(this);
    this.getCurrentDataState = this.getCurrentDataState.bind(this);
    this.getLatLgn = this.getLatLgn.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.setState({ searchText: nextProps.value });
    }
  }

  getCurrentDataState() {
    return this.state.data;
  }

  getLatLgn(locationID, cb) {
    this.geocoder.geocode({ placeId: locationID }, (results, status) => {
      cb(results, status);
    });
  }

  updateInput(searchText) {    
    // console.log('searchText.....',searchText, this.props.value);
    if (searchText.length > 0) {
      this.setState({
        searchText,
      },
        () => {
          const outerScope = this;
          this.service.getPlacePredictions({
            input: this.state.searchText,
            //componentRestrictions: { country: 'us' },
            componentRestrictions:{ country: ["us","ca"] },
            types: this.props.types,
          },
            (predictions) => {
              if (predictions) {
                outerScope.populateData(predictions);                
              }
              else if (this.props.isValidGoogleAddress) {
                this.props.isValidGoogleAddress(false);
              }
            });
        });
    }
    else if (this.props.isFullAddressEmpty) {
      this.props.isFullAddressEmpty(searchText);
    }
  }

  populateData(array) {
    //console.log('array........',array)
    this.setState({ data: array });
  }
  render() {
    return (
      <div>
        <AutoComplete
          id={this.props.id}
          name={this.props.name}
          // value={this.props.value} 
          anchorOrigin={this.props.anchorOrigin}
          animated={this.props.animated || true}
          animation={this.props.animation}
          errorStyle={this.props.errorStyle}
          errorText={this.props.errorText}
          disabled={this.props.disabled}
          floatingLabelText={this.props.labelText}
          fullWidth={this.props.fullWidth || true}
          hintText={this.props.hintText || ' '}
          listStyle={this.props.listStyle}
          maxSearchResults={this.props.maxSearchResults}
          menuCloseDelay={this.props.menuCloseDelay}
          menuStyle={this.props.menuStyle}
          onClose={this.props.onClose}
          open={this.props.open || false}
          IsFullAddress = {this.props.IsFullAddress || false}
          style={this.props.style}
          targetOrigin={this.props.targetOrigin}
          textFieldStyle={this.props.textFieldStyle}
          // Used by Google Places API / No user input
          searchText={this.state.searchText}
          onUpdateInput={this.updateInput}
          onChange={this.updateInput}
          filter={AutoComplete.noFilter}
          //componentRestrictions={{country: 'us'}}
          onNewRequest={(chosenRequest, index) => {
            let dataItem = this.state.data[index];
            // indexing bug
            if (!dataItem) {
              dataItem = this.state.data[0];
            }

            const componentForm = {
              street_number: 'short_name',
              route: 'long_name',
              locality: 'long_name',
              political: 'long_name',
              administrative_area_level_1: 'short_name',
              country: 'short_name',
              postal_code: 'short_name',
              lat: '0.0',
              lng: '0.0'
            };

            // this.getLatLgn(dataItem.place_id, (place) => {
            //   // console.log('results.......',place);
            //   // console.log('results1...lat....',place[0].geometry.location.lat());
            //   // console.log('results2...lng....',place[0].geometry.location.lng());
            //   let addressType = null;
            //   let isLocalityfound = false;
            //   for (let i = 0; i < place[0].address_components.length; i++) {
            //     if(place[0].address_components[i].types[0] === 'locality'){
            //       isLocalityfound = true;
            //     }
            //   }
            //   for (let i = 0; i < place[0].address_components.length; i++) {
            //    if(!isLocalityfound && (place[0].address_components[i].types[0] === 'political' || place[0].address_components[i].types[0] === 'sublocality' || place[0].address_components[i].types[0] === 'sublocality_level_1' || place[0].address_components[i].types[0] === 'administrative_area_level_3'))
            //     { 
            //         place[0].address_components[i].types[0] = 'locality';
            //     }   
            //     addressType = place[0].address_components[i].types[0];

            //     if (componentForm[addressType]) {
            //       let val = place[0].address_components[i][componentForm[addressType]];
            //       componentForm[addressType] = val;
            //     }
            //   }
          
            //   // if(componentForm[addressType] === 'locality' && componentForm[addressType] === null)
            //   // {
            //   //   componentForm[addressType] = componentForm['political'];
            //   // }

            //   // get lat and get lng
            //   componentForm['lat'] = place[0].geometry.location.lat();
            //   componentForm['lng'] = place[0].geometry.location.lng();

            //   if (!this.state.IsFullAddress) {
            //     let Address1 = componentForm.street_number === 'short_name' && componentForm.route === 'long_name' ? '' :
            //       componentForm.street_number === 'short_name' ? componentForm.route : componentForm.street_number + ' ' + componentForm.route;
            //     this.setState({ searchText: Address1 });
            //   }

            //   this.props.getFullAddress(componentForm);
            //   // this.props.results(
            //   //   results.geometry.location.lat(),
            //   //   results.geometry.location.lng(),
            //   // );
            // });
            this.getLatLgn(dataItem.place_id, (place) => {
              let addressComponents = place[0].address_components;
              let city = '';
        
              // Determine city based on priority
              for (let i = 0; i < addressComponents.length; i++) {
                let types = addressComponents[i].types;
                if (types.includes('locality')) {
                  city = addressComponents[i].long_name;
                  break;
                } else if (types.includes('neighborhood') && !city) {
                  city = addressComponents[i].long_name;
                } else if (types.includes('administrative_area_level_3') && !city) {
                  city = addressComponents[i].long_name;
                }
              }
        
              // Fill componentForm with address details
              for (let i = 0; i < addressComponents.length; i++) {
                let addressType = addressComponents[i].types[0];
                if (componentForm[addressType]) {
                  let val = addressComponents[i][componentForm[addressType]];
                  componentForm[addressType] = val;
                }
              }
        
              // Set lat and lng
              componentForm['lat'] = place[0].geometry.location.lat();
              componentForm['lng'] = place[0].geometry.location.lng();
        
              // Set searchText
              if (!this.state.IsFullAddress) {
                let Address1 = componentForm.street_number === 'short_name' && componentForm.route === 'long_name' ? '' :
                  componentForm.street_number === 'short_name' ? componentForm.route : componentForm.street_number + ' ' + componentForm.route;
                this.setState({ searchText: Address1 });
              }
        
              // Pass the full address including the city
              componentForm.locality = city;
              this.props.getFullAddress(componentForm);
            });
          }}
          dataSource={this.state.data.map((item, i, a) => {
            if (i === a.length - 1) {
              return {
                text: '',
                value: (
                  <MenuItem
                    style={{ cursor: 'default' }}
                    disabled
                    children={
                      <div style={{ paddingTop: 20 }}>
                        <img
                          style={{ float: 'right' }}
                          width={96}
                          height={12}
                          src="https://developers.google.com/places/documentation/images/powered-by-google-on-white.png"
                          alt="presentation"
                        />
                      </div>
                    }
                  />
                )
              };
            }
            return {
              text: item.description,
              value: (
                <MenuItem
                  style={this.props.menuItemStyle || {
                    fontSize: 13,
                    display: 'block',
                    paddingRight: 20,
                    overflow: 'hidden',
                  }}
                  innerDivStyle={this.props.innerDivStyle || { paddingRight: 38, paddingLeft: 38 }}
                  // Used by Google Places / No user input
                  primaryText={item.description}
                  leftIcon={
                    <Marker
                      style={{ width: '20px' }}
                    />
                  }
                />
              )
            };
          })
          }
        />
      </div>
    );
  }
}

GooglePlaceAutocomplete.propTypes = {
  // Google componentRestrictions
  componentRestrictions: PropTypes.object,
  types: PropTypes.array,
  // AutoComplete properties
  anchorOrigin: PropTypes.object,
  animated: PropTypes.bool,
  animation: PropTypes.func,
  errorStyle: PropTypes.object,
  errorText: PropTypes.any,
  floatingLabelText: PropTypes.string,
  fullWidth: PropTypes.bool,
  hintText: PropTypes.string,
  listStyle: PropTypes.object,
  maxSearchResults: PropTypes.number,
  menuCloseDelay: PropTypes.number,
  menuProps: PropTypes.object,
  menuStyle: PropTypes.object,
  onClose: PropTypes.func,
  onNewRequest: PropTypes.func,
  onUpdateInput: PropTypes.func,
  open: PropTypes.bool,
  openOnFocus: PropTypes.bool,
  popoverProps: PropTypes.object,
  searchText: PropTypes.string,
  style: PropTypes.object,
  targetOrigin: PropTypes.object,
  textFieldStyle: PropTypes.object,
  // Prop types for dataSource
  innerDivStyle: PropTypes.object,
  menuItemStyle: PropTypes.object,
  results: PropTypes.func,
  name: PropTypes.string,
  IsFullAddress: PropTypes.bool,
  //value: PropTypes.string,
};

{/* <GooglePlaceAutocomplete 
getFullAddress={this.GetFullAddress}  
id={"userAddress"} 
labelText="Address" 
hintText="Enter Address"/>       */}


// function mapStateToProps(state, ownProps) {
//   console.log('ownProps............',ownProps)
//   return {   
//   };
// }

export default GooglePlaceAutocomplete;



// WEBPACK FOOTER //
// ./src/components/GooglePlaceAutocomplete.js